export type AdditionalInfo = { bold?: boolean; icon?: string; question: string; value: boolean };

export type PricePoint = {
  additionalInfo?: AdditionalInfo[];
  addOns?: {
    code: string;
    componentId: string;
    pricePointId: string;
    unitPrice?: string;
  }[];
  allowedStates?: string[];
  asyncAppointmentCost?: string;
  asyncMedicationRefillCost?: string;
  categories?: string[];
  faqDetails?: [
    {
      text: string;
      title: string;
    }
  ];
  initialAppointmentComponentId?: string;
  initialAppointmentCost: string;
  initialAppointmentPricePointId?: string;
  isDefault: boolean;
  isWeightMaintenance?: boolean;
  monthlyPrice: string;
  paymentInterval: {
    qty: number;
    units: 'months' | 'days';
  };
  //NOTE: rename this property after BE changes
  planName?: string;
  planPricePointId: string;
  programId: string;
  subsequentAppointmentComponentId: string;
  subsequentAppointmentCost: string;
  subsequentAppointmentPricePointId: string;
  totalCost: string;
  trialInterval: null | {
    qty: number;
    units: 'months' | 'days';
  };
};

export interface MembershipPlan {
  _id: string;
  additionalInfo: AdditionalInfo[];
  couponCode?: string;
  couponDescription: string;
  couponText: string;
  isComponent?: boolean;
  isUnlimitedPlan: boolean;
  planCode: PlanCodes;
  planName: string;
  priceClass?: string;
  pricePoints: PricePoint[];
}

export enum PlanCodes {
  // AnnualMembership = 'lifemd-annual-membership',
  // Appointment = 'appointment-30',
  ConciergeMembership = 'concierge-care',
  FlexCare = 'limited-access',
  InitialAppointment = 'initial-appointment',
  LifeMDMembership = 'membership',
  LifeMDPlus = 'lifemd-plus',
  MensHealth = 'mens-health',
  MentalHealth = 'mental-health',
  TotalCareMembership = 'total-care',
  UnlimitedMembership = 'unlimited-membership',
  UrgentCare = 'urgent-care',
  WeightManagementMembership = 'weight-management',
  WomenHealth = 'women-health'
}
